export default __webpack_public_path__ + "static/media/drawing-man6-focusfill.e15af9ca.svg";